import { render, staticRenderFns } from "./ResetUserPassword.vue?vue&type=template&id=b8dc7da4&"
import script from "./ResetUserPassword.vue?vue&type=script&lang=js&"
export * from "./ResetUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetUserPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResetUserPassword.vue"
export default component.exports